<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 14:21:08
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-12-29 20:23:18
-->
<template>
  <div class="content">
    <div class="info">
      <span>地块数量：{{ landTotalInfo.landTotalNum || 0 }}块</span>
      <span> 地块面积：{{ landTotalInfo.croplandAreaTotal || 0 }}亩</span>
    </div>
    <div class="map-wrap">
      <div class="initial-btn" @click="initialAddress">
        <i class="iconfont icon-chushidingwei"></i>
      </div>
      <div class="map-div" id="mapDiv" ref="mapDiv"></div>
      <div
        class="map-right-info"
        :class="showRightInfo ? 'map-right-info-show' : 'map-right-info-close'"
      >
        <div class="map-right-info-content">
          <div class="tabs-nav">
            <div class="item">地块信息</div>
          </div>
          <template v-if="contractType == 'trustee'">
            <MapLandInfoVertical
              :curLandInfo="curLandInfo"
            ></MapLandInfoVertical>
          </template>
          <template v-if="contractType == 'transfer'">
            <MapLandInfoHorizontal
              :curLandInfo="curLandInfo"
            ></MapLandInfoHorizontal>
          </template>
          <div class="close-btn" @click="handleChangeRightInfo">
            <i class="el-icon-d-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TalksMap from "@/utils/initMapTalks.js";
import MapLandInfoVertical from "@/components/LandMap/MapLandInfoVertical";
import MapLandInfoHorizontal from "@/components/LandMap/MapLandInfoHorizontal";
import { log } from "util";
export default {
  components: {
    MapLandInfoVertical,
    MapLandInfoHorizontal,
  },
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      landList: [], // 所有的地块
      landTotalInfo: {}, // 地块总的信息
      showRightInfo: false,
      curLandInfo: {}, // 选中地块信息
      mapHasHover: false,
      mapHasSelected: false,
      coordinate: [116.177427669, 28.861500052],
    };
  },
  props: {
    contractId: {
      type: String,
    },
    contractType: {
      type: String,
    },
  },
  watch: {
    landList: {
      handler: function (n) {
        // this.TalksMapDialog.land(
        //   this.landList,
        //   "croplandEdge",
        //   "",
        //   this.mapHasHover,
        //   this.mapHasSelected
        // );
        let lng, lat;
        if (this.landList.length == 0) {
          lng = 116.177427669;
          lat = 28.861500052;
        } else {
          let temp = JSON.parse(this.landList[0].centroid).coordinates;
          lng = temp[0];
          lat = temp[1];
        }
        let Coordinate = {
          x: lng,
          y: lat,
        };
        this.coordinate = Coordinate;
        this.TalksMapDialog.land(
          this.landList,
          "croplandEdge",
          this.landCallBack,
          this.mapHasHover,
          this.mapHasSelected
        );
      },
    },
  },
  mounted() {
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    this.getLandList({ contractId: this.contractId });
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getLandList(params) {
      this.$http.contract.getContractDetailLands(params).then((res) => {
        let { contractLandProtocols, ...data } = res.data;
        this.landTotalInfo = data;
        if (contractLandProtocols && contractLandProtocols.length > 0) {
          this.landList = contractLandProtocols;
        }
      });
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
    /**
     * @descripttion: 绘制地块的回调函数
     * @Author: juanjuanhui
     * @Date: 2021-12-02 21:02:49
     */
    landCallBack(e) {
      this.curLandInfo = {};
      let target = e.target;
      this.showRightInfo = true;
      this.getLandDetail(target.val.id);
    },
    /**
     * @descripttion: 获取地块详细信息
     * @Author: juanjuanhui
     * @Date: 2022-03-14 21:22:15
     * @param {*} id
     */
    getLandDetail(id) {
      this.$http.work.getLandDetail({ id }).then((res) => {
        this.curLandInfo = res.data;
      });
    },
    /**
     * @descripttion: 关闭地图右侧信息
     * @Author: juanjuanhui
     * @Date: 2022-03-10 20:17:50
     */
    handleChangeRightInfo() {
      this.showRightInfo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.content {
  .info {
    padding: 0 0 10px;
    color: #242424;
    span {
      margin-right: 50px;
    }
  }
  .map-wrap {
    position: relative;
    height: 570px;
    .initial-btn {
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 1;
      cursor: pointer;
      width: 40px;
      height: 40px;
      background: #ffffff;
      border-radius: 5px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        color: #018388;
        font-size: 24px;
      }
    }
    .map-div {
      height: 100%;
    }
    .map-right-info {
      position: absolute;
      top: 0;
      right: 0;
      width: 300px;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.75);
      transition: 0.3s;
      &.map-right-info-show {
        transform: translateX(0);
      }
      &.map-right-info-close {
        transform: translateX(120%);
      }
      .close-btn {
        position: absolute;
        top: 50%;
        left: -32px;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 72px;
        cursor: pointer;
        background-color: rgba($color: #000000, $alpha: 0.75);
        .el-icon-d-arrow-right {
          color: #fff;
        }
      }
      .map-right-info-content {
        height: 100%;
        padding: 15px;
        box-sizing: border-box;
        overflow-y: auto;
        /*滚动条样式*/
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(255, 255, 255, 0.2);
        }
        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 0;
          background: rgba(255, 255, 255, 0.1);
        }
        .tabs-nav {
          .item {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            padding: 0 20px;
            color: #fff;
            font-size: 18px;
            z-index: 1;
            &::after {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: -1;
              background-color: #018388;
              transform: skew(-20deg);
            }
            img {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
